import { PerfectScrollBarExternalApiClass } from '../visual/atoms/perfect-scrollbar';

export interface ITabConfigurationElement {
    id: string;
    title?: string;
    titleTemplate?: string;
    subTitle?: string;
    content?: string;
    scrollbar?: boolean;
    padding?: boolean;
    default?: boolean;
    entity?: any;
    tooltip?: boolean;
    unselectable?: boolean;
    headerTitle?: string;
    headerContent?: string;
    isFavourite?: boolean;
}

export interface IVerticalTabHeader {
    template: string;
    scope: angular.IScope;
}

export class VerticalTabConstructor {
    protected tabs: VerticalTabItem[] = [];

    constructor(tabs?: VerticalTabItem[]) {
        this.tabs = tabs || [];
    }

    public addTab(config: ITabConfigurationElement /*id, title, content, scrollbar = true*/): VerticalTabItem {
        const tab = this.mkTab(config);
        this.tabs.push(tab);
        return tab;
    }

    public addSubTab(config: ITabConfigurationElement, parent: VerticalTabItem = null): VerticalTabItem {
        const tab = this.mkTab(config);
        const to: VerticalTabItem = parent || this.tabs[this.tabs.length - 1];
        if (to) {
            tab.parent = to;
            to.subTabs.push(tab);
        }
        return tab;
    }

    public mkTab(config: ITabConfigurationElement): VerticalTabItem {
        if (!config.id) {
            throw 'VerticalTabConstructor no id configured';
        }
        if (!config.title && !config.titleTemplate) {
            throw 'VerticalTabConstructor no suitable title configured';
        }
        const ret = new VerticalTabItem(config);
        //		ret.scrollbar = scrollbar;
        return ret;
    }

    public addTabAfter(id: string, config: ITabConfigurationElement) {
        const index = this.tabs.findIndex(item => item.id === id);
        if (index !== -1) {
            this.tabs.splice(index + 1, 0, this.mkTab(config));
        } else {
            this.addTab(config);
        }
    }

    public addFirst(config: ITabConfigurationElement) {
        this.tabs.unshift(this.mkTab(config));
    }

    public getTabs(): VerticalTabItem[] {
        return this.tabs;
    }
}

export class VerticalTabItem {
    id: ITabConfigurationElement['id'];
    title: ITabConfigurationElement['title'];
    titleTemplate: ITabConfigurationElement['titleTemplate'];
    subTitle: ITabConfigurationElement['subTitle'];
    content: ITabConfigurationElement['content'];
    scrollbar: boolean = false;
    scrollbarApi: PerfectScrollBarExternalApiClass;
    scrollbarApiPromise: Promise<PerfectScrollBarExternalApiClass>;
    scrollbarApiResolver: any;
    subTabs: VerticalTabItem[] = [];
    padding: boolean = true;
    default: boolean = false;
    parent: VerticalTabItem = null;
    entity: any = null;
    tooltip: boolean;
    unselectable: boolean = false;
    headerTitle: string;
    headerContent: string;
    public isFavourite: boolean;
    constructor(config: ITabConfigurationElement) {
        this.id = config.id;
        this.title = config.title;
        this.titleTemplate = config.titleTemplate;
        this.subTitle = config.subTitle;
        this.scrollbar = config.scrollbar !== undefined ? config.scrollbar : true;
        this.padding = config.padding !== undefined ? config.padding : true;
        this.content = config.content;
        this.default = config.default || false;
        this.entity = config.entity;
        this.unselectable = config.unselectable || false;
        this.tooltip = config.tooltip !== undefined ? !!config.tooltip : true;
        this.headerTitle = config.headerTitle;
        this.headerContent = config.headerContent;
        this.isFavourite = config.isFavourite !== undefined ? config.isFavourite : false;
    }
    /*
    not used in reports.report-dialog.ts
    releaseSubTabs():VerticalTabItem[] {
        const ret = [];
        this.subTabs.forEach(subTab => {
            subTab.parent = null;
            ret.push(subTab);
        });
        this.subTabs = [];
        return ret;
    }
    */
    public deactivate(): void {
        delete this.scrollbarApi;
        delete this.scrollbarApiResolver;
        delete this.scrollbarApiPromise;
    }

    public setScrollbarApi(api: PerfectScrollBarExternalApiClass): void {
        this.scrollbarApi = api;
        if (this.scrollbarApiResolver) {
            this.scrollbarApiResolver.resolve(api);
            this.scrollbarApiResolver = null;
        }
    }

    public promiseMeScrollbarApiPlease(): Promise<PerfectScrollBarExternalApiClass> {
        if (!this.scrollbarApiPromise) {
            const theThis = this;
            this.scrollbarApiPromise = new Promise(resolve => {
                theThis.scrollbarApiResolver = resolve;
            });
        }
        return this.scrollbarApiPromise;
    }
}
